import { useState } from "react";
import { Share2, MessageCircle, Send, Mail, Copy, Facebook } from "lucide-react";
import { toast } from "sonner";

const APP_URL = "https://gohelperservice.ca";
const MESSAGE = `Découvre Go Helper — la plateforme locale qui te connecte à des helpers près de chez toi pour tes tâches du quotidien : déneigement, livraison, courses, montage IKEA, navette aéroport et plus encore. Inscris-toi : ${APP_URL}`;

export default function ShareApp({ variant = "icon", className = "" }) {
  const [open, setOpen] = useState(false);

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Go Helper — Besoin d'aide ? On est là.",
          text: MESSAGE,
          url: APP_URL,
        });
        return;
      } catch {/* user cancelled */}
    }
    setOpen(true);
  };

  const copyLink = () => {
    navigator.clipboard.writeText(APP_URL);
    toast.success("Lien copié !");
    setOpen(false);
  };

  const channels = [
    { id: "sms", icon: MessageCircle, label: "SMS", href: `sms:?&body=${encodeURIComponent(MESSAGE)}` },
    { id: "whatsapp", icon: Send, label: "WhatsApp", href: `https://wa.me/?text=${encodeURIComponent(MESSAGE)}` },
    { id: "facebook", icon: Facebook, label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(APP_URL)}` },
    { id: "messenger", icon: Send, label: "Messenger", href: `https://www.facebook.com/dialog/send?app_id=&link=${encodeURIComponent(APP_URL)}&redirect_uri=${encodeURIComponent(APP_URL)}` },
    { id: "email", icon: Mail, label: "Email", href: `mailto:?subject=${encodeURIComponent("Découvre Go Helper")}&body=${encodeURIComponent(MESSAGE)}` },
  ];

  return (
    <>
      {variant === "icon" ? (
        <button
          onClick={nativeShare}
          className={`inline-flex items-center justify-center h-9 w-9 rounded-full bg-surface hover:bg-lime text-navy transition-colors ${className}`}
          aria-label="Partager l'application"
          data-testid="share-app-icon"
        >
          <Share2 size={16} />
        </button>
      ) : (
        <button
          onClick={nativeShare}
          className={`inline-flex items-center gap-2 bg-lime hover:scale-105 text-navy font-bold rounded-full px-4 py-2 text-sm transition-transform ${className}`}
          data-testid="share-app-btn"
        >
          <Share2 size={14} /> Partager
        </button>
      )}

      {open && (
        <div className="fixed inset-0 z-[9999] bg-black/50 flex items-end md:items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="share-app-fallback">
          <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-3xl w-full max-w-md p-6 shadow-2xl">
            <h3 className="font-heading font-black text-xl text-navy">Partage Go Helper</h3>
            <p className="text-sm text-[#475569] mt-1">Aide la plateforme à grandir — partage avec tes amis !</p>
            <div className="mt-5 grid grid-cols-3 gap-3">
              {channels.map((c) => {
                const Icon = c.icon;
                return (
                  <a key={c.id} href={c.href} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}
                    className="flex flex-col items-center gap-2 p-3 bg-surface hover:bg-lime/20 rounded-xl transition-colors" data-testid={`share-fallback-${c.id}`}>
                    <Icon size={24} className="text-navy" />
                    <span className="text-xs font-bold text-navy">{c.label}</span>
                  </a>
                );
              })}
              <button onClick={copyLink} className="flex flex-col items-center gap-2 p-3 bg-surface hover:bg-lime/20 rounded-xl transition-colors" data-testid="share-fallback-copy">
                <Copy size={24} className="text-navy" />
                <span className="text-xs font-bold text-navy">Copier</span>
              </button>
            </div>
            <button onClick={() => setOpen(false)} className="btn-outline w-full mt-5" data-testid="share-fallback-close">Fermer</button>
          </div>
        </div>
      )}
    </>
  );
}
